import {Injectable} from '@angular/core';
import {BasedataService} from '@docma-mm-core/shared/basedata.service';
import {UntilDestroy} from '@ngneat/until-destroy';
import {FaultsImportService} from '../../faults-import.service';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {MydocmaDatePipe, MydocmaNumberPipe} from '@mydocma/common';
import {HttpClient} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {BaseImportService} from './base-import.service';

@UntilDestroy()
@Injectable()
export class PreviewImportService extends BaseImportService {

  constructor(protected faultsImportService: FaultsImportService,
              protected translateService: TranslateService,
              protected datepipe: MydocmaDatePipe,
              protected numberpipe: MydocmaNumberPipe,
              protected http: HttpClient,
              protected configService: ConfigService) {

    super(faultsImportService, translateService, datepipe, numberpipe, http, configService);
  }

}
